import Vue from 'vue'
import {mapGetters,mapActions} from 'vuex'

import ApiClientsService from 'js/services/api/api-clients.js'
import BillingTransactionsService from 'js/services/api/billing/transactions.js'
import BillingProductsService from 'js/services/api/billing/product_validations.js'

import Travel from './_travel'
import Product from './_products'
import template from './index.pug'


const PRODUCT_TYPE = 13

const TSC_CODE = 1
const QR_ID_CODE = 2
const PROD_CODE = 3
const TNE_CODE = 4

export default Vue.extend({
  name: 'municipality-data-page',
  template: template(),
  components: {Travel, Product},
  data() {
    return {
      travels: [],
      loadingTravels: false,
      okProfile: false,
      currentAlias: null,
      // Filtros de la vista
      mediaType: QR_ID_CODE,
      selectedTscMediaCode: '',
      tscs: [],
      products: [],
      paginationTravels: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      },
      order: {
        order_by: 'code',
        order_dir: 'asc'
      },
      paginationProducts: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      },
      paginationTscs: {
        currentPage: 1,
        limit: 10,
        totalElements: null
      }
    }
  },
  computed: {
    inAccountTab() {
      return this.mediaType === QR_ID_CODE
    },
    inTscTab() {
      return this.mediaType === TSC_CODE
    },
    inProductTab() {
      return this.mediaType === PROD_CODE
    },
    selectedMediaTypes() {
      return this.mediaType === QR_ID_CODE ? [QR_ID_CODE, TNE_CODE] : [TSC_CODE]
    },
    tscOptions() {
      return this.tscs.map(tsc => ({
        label: this.$t('travels.tscOption', tsc).trim(),
        value: tsc.CardSerialNumber
      }))
    },
    hasMultipleTscs() {
      return this.tscOptions.length > 1
    }
  },
  watch: {
    $currentAccount: {
      handler: 'checkIfCanRequestTravels',
      immediate: true
    },
    tscs() {
      this.selectFirstTsc()
    },
    mediaType() {
      if (this.mediaType == 3) {
        this.getProducts()
      } else {
        this.getTravels()
      }
    },
    selectedTscMediaCode() {
      this.getTravels()
    }
  },

  methods: {
    changeLimitTravels(limit) {
      this.paginationTravels.limit = limit
      this.paginationTravels.currentPage = 1
      this.getTravels()
    },
    changePageTravels(page) {
      this.paginationTravels.currentPage = page
      this.getTravels()
    },
    changeLimitTscs(limit) {
      this.paginationTscs.limit = limit
      this.paginationTscs.currentPage = 1
      this.getTravels()
    },
    changePageTscs(page) {
      this.paginationTscs.currentPage = page
      this.getTravels()
    },
    changeLimitProducts(limit) {
      this.paginationProducts.limit = limit
      this.paginationProducts.currentPage = 1
      this.getProducts()
    },
    changePageProducts(page) {
      this.paginationProducts.currentPage = page
      this.getProducts()
    },
    changeTab(tabIndex) {
      this.mediaType = tabIndex
    },
    checkIfCanRequestTravels() {
      const vm = this
      // Tengo cuenta en el municipio actual
      if (vm.$currentAccount) {
        vm.loadingTravels = true
        const params = {
          administrative_area_id: vm.$currentAccount.administrative_area_id,
          rut: vm.$currentAccount.rut
        }

        ApiClientsService.clientMediaInfo(params).then(response => {
          const data = response.data
          this.tscs = data.filter(media => media.MediaType === TSC_CODE.toString())
          // Hay medios en Everilion
          vm.okProfile = true
          vm.getTravels()
        // No hay medios en Everilion
        }, () => {
          vm.loadingTravels = false
        })
      }
    },
    getProducts() {
      const vm = this
      const params = {
        administrative_area_id: vm.$currentAccount.administrative_area_id,
        rut: vm.$currentAccount.rut,
        is_transfer: false,
        order_by: 'operation_date',
        order_dir: 'desc',
        per: 50,
        template: 'client_travel'
      }

      BillingProductsService.index(params).then(response => {
        this.products = response
        this.products = this.products.filter(media => media.type === PRODUCT_TYPE)
        // eslint-disable-next-line max-len
        const firstPosition = (this.paginationProducts.currentPage - 1) * this.paginationProducts.limit
        this.paginationProducts.totalElements = this.products.length
        // eslint-disable-next-line max-len
        this.products = this.products.slice(firstPosition, firstPosition + this.paginationProducts.limit)
      })
    },
    getTravels() {
      // eslint-disable-next-line max-len
      this.currentAlias = this.tscOptions.filter(item => item.value === this.selectedTscMediaCode)[0]

      const params = {
        administrative_area_id: this.$currentAccount.administrative_area_id,
        media_code: this.inTscTab ? this.selectedTscMediaCode : '',
        media_type_array: this.selectedMediaTypes,
        client_travels_media_type: this.mediaType,
        order_by: 'operation_date',
        order_dir: 'desc',
        per: 50,
        template: 'client_travel'
      }

      BillingTransactionsService.index(params).then(response => {
        this.loadingTravels = false
        this.travels = response
        
        if (this.inTscTab) {
          this.paginationTscs.totalElements = this.travels.length
          const firstPosition = (this.paginationTscs.currentPage - 1) * this.paginationTscs.limit
          if (this.paginationTscs.limit) {
            // eslint-disable-next-line max-len
            this.travels = this.travels.slice(firstPosition, firstPosition + this.paginationTscs.limit)
          } else {
            this.travels = this.travels.slice(firstPosition, firstPosition + 10)
          }
        } else {
          this.paginationTravels.totalElements = this.travels.length
          // eslint-disable-next-line max-len
          const firstPosition = (this.paginationTravels.currentPage - 1) * this.paginationTravels.limit
          if (this.paginationTravels.limit) {
            // eslint-disable-next-line max-len
            this.travels = this.travels.slice(firstPosition, firstPosition + this.paginationTravels.limit)
          } else {
            this.travels = this.travels.slice(firstPosition, firstPosition + 10)
          }
        }
      }, () => {
        this.loadingTravels = false
      })
      
    },

    /*
     * Seleccionar la primera TSC que haya si no hay ninguna seleccionada
     */
    selectFirstTsc() {
      if (this.tscs.length > 0) {
        const selectedTsc = this.tscs.find(
          tsc => tsc.CardSerialNumber === this.selectedTscMediaCode
        )

        if (selectedTsc === undefined) {
          this.selectedTscMediaCode = this.tscs[0].CardSerialNumber
        }
      } else {
        this.selectedTscMediaCode = ''
      }
    },

    reloadView() {
      const vm = this
      Vue.store.dispatch('loadCurrentUser').then(() => {
        vm.checkIfCanRequestTravels()
      })
    },

    getMediaTypeNoDataText() {
      if (this.mediaType === TSC_CODE) {
        return this.$t('travels.noTravelsTsc')
      } else if (this.mediaType === PROD_CODE) {
        return this.$t('travels.noTravelsProduct')
      }

      return this.$t('travels.noTravelsQR')
    },

    getMediaTypeNoDataImg() {
      if (this.mediaType === TSC_CODE) {
        return require('assets/images/ilustrations/private-area/no-travels-tsc.svg')
      } else if (this.mediaType === PROD_CODE) {
        return require('assets/images/ilustrations/private-area/no-travels-product.svg')
      }

      return require('assets/images/ilustrations/private-area/no-travels-qr.svg')
    },

    travelTranslationObject(travel) {
      return {
        mediaType: this.$t(`travels.mediaTypes.${travel.media_type}`),
        mediaCode: travel.media_code
      }
    },

    loadTabs() {
      const vm = this

      if(this.$administrativeArea.config.product_available){
        return [
          {
            id: QR_ID_CODE,
            title: vm.$t(`travels.tabs.${QR_ID_CODE}`)
          },
          {
            id: TSC_CODE,
            title: vm.$t(`travels.tabs.${TSC_CODE}`)
          },
          {
            id: PROD_CODE,
            title: vm.$t(`travels.tabs.${PROD_CODE}`)
          }
        ]
      }else{
        return [
          {
            id: QR_ID_CODE,
            title: vm.$t(`travels.tabs.${QR_ID_CODE}`)
          },
          {
            id: TSC_CODE,
            title: vm.$t(`travels.tabs.${TSC_CODE}`)
          }
        ]
      }
    }
  },
  mounted(){
    for(var i=0;i<this.travels.length ;i++){
      var id = 'travel-'+this.travels[i].id
          var boton = document.getElementById(id);
      var left = this
          // Agregar un listener para el evento focus
      boton.addEventListener('focus', function() {
        var textoescuchar=left.$t('textoVoz.selectorLinea') 
        left.escucharAudio(textoescuchar )
        this.opcionSelectotLinea =0
        });
      }
  }
})
